import * as z from "zod/v4";
import { boolean, literal } from "zod/v4";
import { ShippingAddressToUpdateSchema } from "../../agents/support-agents/confirm-update-order-shipping-address";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";
// ADDRESS INFO
export const AddressInformationCustomerInputContentSchema = z.object({
  addressInfo: ShippingAddressToUpdateSchema.optional(),
  cancelled: boolean().optional(),
  confirmed: boolean().optional(),
});

export type AddressInformationCustomerInputContent = z.infer<
  typeof AddressInformationCustomerInputContentSchema
>;

/**
 * Message type for when ai wants to collect address information from the customer.
 */
const AddressInformationMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.UPDATE_ADDRESS),
  structuredContent: ShippingAddressToUpdateSchema.optional(),
  customerInputContent: AddressInformationCustomerInputContentSchema.optional(),
});

export const AddressInformationMessageDbParser =
  AddressInformationMessageSchema.merge(AutoGeneratedFieldsSchema);

export type AddressInformationMessageType = z.infer<
  typeof AddressInformationMessageDbParser
>;
